// Main container styles
export const mainContainer = {
  backgroundColor: '#FFFFFF',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
};

export const SnackBarComponent = {
  position: 'fixed',
  left: '32%',
  bottom: 0,
  zIndex: 99,
};

// Header styles
export const headerContainer = {
  display: 'flex',
  alignItems: 'center',
  padding: '16px 20px',
  borderBottom: '1px solid #E5E7EB',
  backgroundColor: 'white',
};

export const closeButton = {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  border: '1px solid #0F48B8',
  '&:hover': {
    backgroundColor: '#F3F4F6',
  },
};

export const headerTitle = {
  color: 'var(--Navy---navy-main, #061E44)',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: 'Inter',
  fontSize: '32px',
  fontStyle: 'normal',
  fontWeight: 800,
  lineHeight: 'normal',
};

export const headerTextContainer = {
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '12px',
};

// Content area styles
export const contentContainer = {
  flex: 1,
  padding: '24px 20px 40px 20px',
  backgroundColor: 'white',
  overflowY: 'visible',
};

// Members section styles
export const membersSection = {
  marginBottom: '24px',
};

// Spacing between autocompletes
export const autocompleteSpacing = {
  marginBottom: '24px',
};

// Footer styles
export const footerContainer = {
  display: 'flex',
  minHeight: '80px',
  padding: '0 24px',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '12px',
  flexShrink: 0,
  alignSelf: 'stretch',
  borderTop: '1px solid var(--Greyscale---grey-60, #CDD4E3)',
  marginTop: '120px',
};

export const createButton = {
  borderRadius: '100px',
  background: 'var(--primary-blue-primary-main, #0F48B8)',
  display: 'flex',
  minHeight: '40px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  color: 'white',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  padding: '0 24px',
  boxShadow: 'none',
  '&:hover': {
    background: 'var(--primary-blue-primary-main, #0F48B8)',
    boxShadow: 'none',
  },
  '&:disabled': {
    backgroundColor: '#9CA3AF',
    boxShadow: 'none',
  },
};

/**
 * Returns button styles based on disabled state
 * @param {boolean} isDisabled - Whether the button is disabled
 * @returns {Object} - Button style object
 */
export const getCreateButtonStyles = (isDisabled) => {
  if (isDisabled) {
    return {
      ...createButton,
      backgroundColor: '#9CA3AF',
      background: '#9CA3AF',
      color: '#FFFFFF',
      cursor: 'not-allowed',
    };
  }
  
  return {
    ...createButton,
    backgroundColor: 'var(--primary-blue-primary-main, #0F48B8)',
    background: 'var(--primary-blue-primary-main, #0F48B8)',
    color: '#FFFFFF',
  };
};

export const cancelButton = {
  display: 'flex',
  height: '40px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '100px',
  border: '1px solid var(--Navy---navy-main, #061E44)',
  backgroundColor: 'white',
  color: '#374151',
  padding: '0 24px',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: 'white',
    border: '1px solid var(--Navy---navy-main, #061E44)',
  },
};

export const errorMessage = {
  color: 'error.main',
  marginTop: '8px',
  fontSize: '14px',
};
